import React, { Component } from "react";
import ReversalReceipt from "../components/TransactionReversal/ReversalReceipt";
import querySearch from "stringquery";

import { getTransactionReversalData } from "../services/ReportService";

export default class TransactionReversalReceipt extends Component {
	constructor() {
		super();
		this.state = { reportData: null };
	}
	componentDidMount() {
		const query = querySearch(window.location.search);
		getTransactionReversalData(query.tid, query.lang).then((res) => {
			this.setState({ reportData: res.data, urldata: query.v });
			document.title = "Transaction_Reversal_" + res.data.transactionNumber;
		});
	}
	render() {
		return this.state.reportData ? (
			<div style={{ height: "100%" }}>
				<ReversalReceipt
					result={this.state.reportData}
					isBankCopy={false}
					copyPrint={this.state.urldata}
				/>
				<ReversalReceipt result={this.state.reportData} isBankCopy={true} />
			</div>
		) : (
			<div></div>
		);
	}
}
